// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-media-links[data-v-13edf868]{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;margin:3em 1.4em 2em 1.8em}.social-media-links a[data-v-13edf868]{display:block;height:auto;max-width:4em;min-width:2em;width:10vw}.social-media-links a[data-v-13edf868]:active{filter:brightness(60%)}.social-media-links.desktop[data-v-13edf868]{gap:2vw;justify-content:flex-start;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
